import { useToast } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import Button from "../Button/Button";
import CSS from "./styles.module.css";
import QuestionBox from "../QuestionBox/QuestionBox";
import QuestionSets from "../QuestionSets/QuestionSets";
import Switch from "../Switch/Switch";

const DocPage = ({ children, isActive }) => {
	const ContentRef = useRef(null);
	const toast = useToast();

	const [showAllAnswers, setShowAllAnswers] = useState(false);
	const allAnswerSwitch = useRef(null);

	const [output, setOutput] = useState([]);

	useEffect(() => {
		setOutput([...children]);
	}, [children]);

	useEffect(() => {
		if (isActive === false) {
			setOutput([]);
		}
	}, [isActive]);

	const getText = (node) => {
		let text = "";
		node.childNodes.forEach((child) => {
			if (child.nodeType === Node.TEXT_NODE) {
				// If it's a text node
				text += child.textContent;
			} else if (child.classList.contains("HiddenContent")) {
				// If it's a 'HiddenContent' element
				text += "\n"; // Add a new line
			} else if (!child.classList.contains("HiddenContent2")) {
				// If it's not a 'HiddenContent2' element
				text += getText(child) + "\n"; // Recursively get text from this child
			}
		});
		return text;
	};

	const copyText = () => {
		let text = getText(ContentRef.current);
		navigator.clipboard.writeText(text);
		toast({
			description: "Copied to Clipboard",
			status: "success",
			duration: 5000,
			isClosable: true,
			position: "bottom-left",
		});
	};

	const handleEdit = () => {
		ContentRef.current.contentEditable = true;
		ContentRef.current.focus();
	};

	const handleEditExit = (e) => {
		e.target.contentEditable = false;
	};

	const allAnswerHandler = (e) => {
		setShowAllAnswers(!showAllAnswers);
	};

	return (
		<div
			className={`${CSS.Container} ${isActive ? CSS.ContainerActive : ""} ${
				CSS.contentBody
			}`}
			ref={ContentRef}
		>
			<div className={CSS.MainHeading} contentEditable={false}>
				<h1>Interview Questions</h1>
				<div
					className={`${CSS.Toggle} ${CSS.MainToggle} ${"HiddenContent"}`}
					contentEditable={false}
				>
					<label htmlFor="answerBtn">
						<font>
							{showAllAnswers ? "Hide All Answers" : "Show All Answers"}
						</font>
					</label>
					<Switch
						id="answerBtn"
						checked={showAllAnswers}
						onClick={allAnswerHandler}
					/>
				</div>
			</div>
			{children &&
				output &&
				output.map((item, ind) => (
					<QuestionSets
						key={ind}
						item={item}
						ind={ind}
						isActive={showAllAnswers}
					/>
				))}

			<div
				className={`${CSS.Actionables} ${"HiddenContent"}`}
				id="actionables"
				contentEditable={false}
			>
				<a href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Frecooty.com%2F">
					<Button leftIcon="rocket_launch" className={CSS.PostButton}>
						Post a free job to
						<br />
						250+ Job Boards
					</Button>
				</a>
				<Button
					leftIcon="content_copy"
					onClick={copyText}
					className={CSS.CopyButton}
				>
					Copy
				</Button>
			</div>
		</div>
	);
};

export default DocPage;
